import { FETCH_DEVICES, PUT_DEVICE } from '../actions/devices';

const initialState = {
  fetching: true,
  data: []
}

const devices = (state = initialState, action) => {
  switch(action.type) {
    case `${FETCH_DEVICES}_PENDING`:
      return { ...state, fetching: true }
    case `${FETCH_DEVICES}_FULFILLED`:
      return { fetching: false, data: action.payload }
    // case `${PUT_DEVICE}_PENDING`:
    //   return state;
    case `${PUT_DEVICE}_FULFILLED`:
      return { ...state, data: state.data.map(d => d.id === action.payload.id ? action.payload : d)};
    default:
      return state;
  }
}

export default devices;

// Selectors

import Feature from 'ol/feature';
import Point from 'ol/geom/point';
import proj from 'ol/proj';

export const getFeaturesByProfile = (devices) => {
  const byProfile = {};
  devices.forEach(device => {
    if(!byProfile[device.profile_id]) {
      byProfile[device.profile_id] = [toFeature(device)];
    } else {
      byProfile[device.profile_id].push(toFeature(device));
    }
  });
  return byProfile;
}

export const getFeaturesWithoutASchedule = (devices, schedules) => {
  let deviceIdsWithSchedule = [];
  schedules.forEach(s => { deviceIdsWithSchedule = deviceIdsWithSchedule.concat(s.device_addresses) });
  return devices.filter(d => deviceIdsWithSchedule.indexOf(d.uid) === -1).map(toFeature);
}

export const getFeaturesBySchedule = (devices, schedules) => {
  const bySchedule = {};
  schedules.forEach(s => {
    bySchedule[s.id] = s.device_addresses.map(d_addr => devices.find(d => d.uid === d_addr)).map(toFeature);
  })
  return bySchedule;
}

export const toFeature = (device) => {
  const point = new Point(proj.fromLonLat([device.longitude, device.latitude]))
  return new Feature({
    geometry: point,
    id: device.id,
    profile_id: device.profile_id,
    uid: device.uid,
    name: device.name,
    modus: device.modus,
    lamp_brightness_percentage: device.lamp_brightness_percentage
  });
}



// WEBPACK FOOTER //
// ./src/reducers/devices.js